import Reviews from "./Reviews.page";

export default Reviews;
